import {Loader} from 'organization/theme/Loader'
import React from 'react'

export function BasicLoader() {
  return (
    <div id="preloader">
      <Loader />
    </div>
  )
}
